import { computed, type FunctionalComponent } from 'vue'
import { InfoBanner } from 'components/info-banner'
import type { AssetInfoBannerProps } from './types'
import { EAssetType, type IAsset } from 'findef'
import { prettyAssetType } from '@/utils/asset'
import { AssetImageV2 } from 'components/asset-image-v2'
// @ts-ignore
import IconFork from "components/icons/IconFork"
import IconTag from 'components/icons/IconTag'
import type { InfoBannerLabel } from 'components/info-banner/type'

export const AssetInfoBanner = (props: AssetInfoBannerProps) => {
	const asset = computed(() => props.formState?.asset)

	const tag = computed(() => {
		if (!asset.value) return undefined
		switch (asset.value.type) {
			case EAssetType.EQUITY:
			case EAssetType.CRYPTO:
			case EAssetType.COMMODITY:
				return asset.value.organizationNumber || asset.value.symbol || asset.value.companyProfile?.isin || asset.value.cryptoQuote?.symbol || asset.value.commodityQuote?.symbol
			case EAssetType.REAL_ESTATE:
				return asset.value.address || [asset.value.zip, asset.value.city].filter(Boolean).join(' ')
			default:
				return undefined
		}
	})

	const title = computed(() => asset.value?.name ?? 'Company')
	const subtitle = computed(() => {
		if (!asset.value) return undefined
		return prettyAssetType(asset.value.type, asset.value.listed, asset.value.subtypes, false, true)
	})

	const labels = computed<InfoBannerLabel[]>(() => {
		const result: InfoBannerLabel[] = [
			{
				icon: IconFork as FunctionalComponent<any>,
				text: `Owned by ${props.ownerLabel || 'Me'}`,
				border: true,
				textClass: 'truncate',
				type: 'owned-by'
			}
		]

		if (tag.value) {
			result.push({
				icon: IconTag as FunctionalComponent<any>,
				text: tag.value,
				border: true,
				textClass: 'truncate',
				type: 'tag'
			})
		}

		return result
	})

	return (
		<InfoBanner
			title={title.value}
			subtitle={subtitle.value}
			icon={() => <AssetImageV2 asset={asset.value as Partial<IAsset>} size="md" variant="gray" />}
			labels={labels.value}
		/>
	)
}

export default AssetInfoBanner
